import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

interface LabelProps {
    bottomMargin?: number;
    isRequired?: boolean;
}

interface InfoTextProps {
    topMargin?: number;
}

export const Label = styled.div<LabelProps>`
    font-weight: bold;
    font-size: 12px;
    color: ${token('color.text.subtle')};
    margin-bottom: ${props => (props.bottomMargin ? props.bottomMargin : '0')}px;

    ${props =>
        props.isRequired &&
        `
    ::after {
      content: ' *';
      color: ${token('color.text.accent.red.bolder')};
    }
  `}
`;

export const InfoText = styled.div<InfoTextProps>`
    font-weight: 400;
    line-height: 16px;
    font-size: 12px;
    color: ${token('color.text.subtlest')};
    margin-top: ${props => (props.topMargin ? props.topMargin : '0')}px;

    a {
        text-decoration: none;
        cursor: pointer;
    }

    .italic {
        font-style: italic;
    }
`;
